<template>
  <div>
    <!-- 左邊菜單 -->
    <div id="offcanvas-overlay" class="menu-desktop" uk-offcanvas="overlay: true">
      <div class="uk-offcanvas-bar">
        <div class="sidebar pl-0 pr-0" style="width:240px !important">
          <button class="uk-offcanvas-close" type="button" style="color: #333;" uk-close></button>
          <section class="sidebar__section menu-m">
            <div class="menu-m-logo">
              <!-- <img src="../images/soonnet-logo.png"> -->
            </div>
            <div class="menu-m-account">
              <!-- <img class="account-icon" alt="" :src=""> -->
              <avatarVue :src="getimage" class="mr-2" v-if="getusers"></avatarVue>
              <avatarVue :src="getimage" class="mr-2" v-else @click.native="cusLogin()" style="cursor: pointer;">
              </avatarVue>
              <div>
                <span v-if="getusers">{{ getusers.displayName }}</span>
                <a v-else @click="cusLogin()"><span class="line-h47">登錄/註冊</span></a>
                <!-- <a>查看我的個人主頁</a> -->
                <router-link v-if="getusers"
                  :to="{ name: 'customerPublishLook', query: { authorId: getusers.userId } }">{{ $t('header.Checkprofile')
                  }}</router-link>
              </div>
            </div>

            <ul class="uk-nav-default classification lang" uk-nav>
              <li class="uk-parent">
                <a href="#" class="classification-title">
                  <i class="fas fa-globe-asia  mr-2"></i>
                  <span>{{ $t('header.Websitelanguage') }}</span>
                  <span uk-nav-parent-icon></span>
                </a>
                <ul class="uk-nav-sub">
                  <li>
                    <a class="sidebar__section__link sidebar__section__link--selected" @click="setIl18('zh')"
                      href="javascript:void(0)">
                      <span>{{ $t('header.TraditionalChinese') }}</span>
                    </a>
                  </li>
                  <li>
                    <a class="sidebar__section__link" href="javascript:void(0)" @click="setIl18('en')">
                      <span>English</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>

            <router-link :to="{ name: 'albumIndex' }" class="sidebar__section__link">
              <i class="	fas fa-images	mr-2"></i>
              <span>{{ $t("header.albumIndex") }}</span>
            </router-link>
            <router-link :to="{ name: 'eventList' }" class="sidebar__section__link">

              <i class="	fas fa-calendar	mr-2"></i>
              <span>{{ $t("header.eventList") }}</span>
            </router-link>
            <router-link :to="{ name: 'articleList' }" class="sidebar__section__link">
              <i class="fas fa-comment-alt mr-2" />
              <span>{{ $t("header.articleList") }}</span>
            </router-link>
            <router-link :to="{ name: 'blog' }" class="sidebar__section__link">
              <i class=" fas fa-pen-square mr-2"></i>
              <span>{{ $t("header.blog") }}</span>
            </router-link>
            <router-link :to="{ name: 'VideoIndex' }" class="sidebar__section__link">
              <i class="fas fa-film mr-2" />
              <span>{{ $t("header.VideoIndex") }}</span>
            </router-link>
            <router-link :to="{ name: 'FeedCloud' }" class="sidebar__section__link">
              <i class="fas fa-file-video mr-2" />
              <span>{{ $t("Index.FeedCloud") }}</span>
            </router-link>
          </section>

          <ul class="uk-nav-default classification" uk-nav>
            <li class="uk-parent">
              <a href="#" class="classification-title">
                官方頻道
                <span uk-nav-parent-icon></span>
              </a>
              <ul class="uk-nav-sub">
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'VideoIndexnew' }"
                    style="padding-left: 18px;" href="javascript:void(0)" @click="sidebarChange('VideoIndexnew')">
                    <img class="account-icon" alt="" style="height: 36px;" src="../../assets/images/soonnettv-logo.jpg">
                    <span>SOONNET TV</span>
                  </a>
                </li>
                <li>
                  <a class="sidebar__section__link" href="http://live.soonnet.org/">
                    <i class="fas fa-broadcast-tower	fa-fw mr-1"></i>
                    <span>賽事直播</span>
                  </a>
                </li>
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'videoprogramme' }"
                    href="javascript:void(0)" @click="sidebarChange('videoprogramme')">
                    <i class="	fas fa-video	fa-fw mr-1"></i>
                    <span>獨家節目</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="uk-parent">
              <a href="#" class="classification-title">
                影音頻道
                <span uk-nav-parent-icon></span>
              </a>
              <ul class="uk-nav-sub">
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'mychannel' }"
                    @click="sidebarChange('mychannel')" href="javascript:void(0)">
                    <i class="fas fa-play-circle fa-fw mr-1"></i>
                    <span>你的頻道</span>
                  </a>
                </li>
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'videolibrary' }"
                    @click="sidebarChange('videolibrary')" href="javascript:void(0)">
                    <i class="fas fa-video	fa-fw mr-1"></i>
                    <span>你的影片</span>
                  </a>
                </li>
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'favorite' }"
                    @click="sidebarChange('favorite')" href="javascript:void(0)">
                    <i class="fas fa-bookmark	fa-fw mr-1"></i>
                    <span>收藏影片</span>
                  </a>
                </li>
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'history' }"
                    @click="sidebarChange('history')" href="javascript:void(0)">
                    <i class="fas fa-history	fa-fw mr-1"></i>
                    <span>觀看紀錄</span>
                  </a>
                </li>
                <li>
                  <a :class="{ 'sidebar__section__link': true, 'link-selected': sidebarClass == 'subscription' }"
                    @click="sidebarChange('subscription')" href="javascript:void(0)">
                    <i class="fas fa-bell	fa-fw mr-1"></i>
                    <span>訂閱列表</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="uk-parent">
              <a href="#" class="classification-title">
                社群動態
                <span uk-nav-parent-icon></span>
              </a>
              <ul class="uk-nav-sub">
                <li class="desktop-display">
                  <router-link :to="{ name: 'customerPublish' }" class="sidebar__section__link">
                    <i class="fa fa-user-circle fa-fw mr-1"></i>
                    <span>個人主頁</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'feed' }" class="sidebar__section__link">
                    <i class="el-icon-postcard fa-fw mr-1"></i>
                    <span>動態主頁</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'feedGroup_haveGroup' }" class="sidebar__section__link">
                    <i class="fas fa-users fa-fw mr-1"></i>
                    <span>群 組</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'feedGroup_groupAddAcc' }" class="sidebar__section__link">
                    <i class="fas fa-user-friends fa-fw mr-1"></i>
                    <span>好友列表</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'customerPrivateMessage' }" class="sidebar__section__link">
                    <i class="fas fa-comments fa-fw mr-1"></i>
                    <span>私訊</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="uk-parent">
              <a href="#" class="classification-title">
                活動資訊
                <span uk-nav-parent-icon></span>
              </a>
              <ul class="uk-nav-sub">
                <li>
                  <router-link :to="{ name: 'eventList' }" class="sidebar__section__link">
                    <i class="fas fa-calendar fa-fw mr-1"></i>
                    <span>活動列表</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'sendmessage' }" class="sidebar__section__link">
                    <i class="fas fa-folder-plus fa-fw mr-1"></i>
                    <span>提供活動資訊</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>

          <section class="sidebar__section">
            <router-link :to="{ name: 'customerInfo' }" class="sidebar__section__link">
              <i class="fas fa-cog fa-fw mr-1"></i>
              <span>設定</span>
            </router-link>
            <router-link :to="{ name: 'contact' }" class="sidebar__section__link">
              <i class="fas fa-phone mr-1"></i>
              <span>聯絡我們</span>
            </router-link>
          </section>

          <section class="social-social-m menu-m">
            <a class="social-btn"><i class="bi bi-facebook"></i></a>
            <a class="social-btn"><i class="bi bi-instagram"></i></a>
            <a class="social-btn"><i class="bi bi-youtube"></i></a>
          </section>
        </div>
      </div>
    </div>
    <!-- ./左邊菜單 -->
  </div>
</template>
<script>
import avatarVue from "../common/avatar.vue";
export default {
  name: "VideoNavigation",
  props: {

  },
  //組件
  components: {
    avatarVue
  },
  //观察器
  watch: {

  },
  //计算属性
  computed: {
    getimage () {
      if (this.$store.getters.getcustomer != null) {
        return (
          this.$store.getters.getcustomer.userLogoBig
        );
      } else {
        return "https://api.soonnet.org/Userlogo_Smail.jpg";
      }
    },
    getusers () {
      if (this.user == null) {
        this.user = this.$store.getters.getcustomer;
      }
      return this.user;
    },
  },
  data () {
    return {
      sidebarClass: "",
      user: null,
      sidebarArray:['VideoIndexnew','subscription','history','favorite','videolibrary','mychannel','videoprogramme']
    };
  },
  //DOM加載前
  created () {
    if(this.sidebarArray.includes(this.$route.name))
      this.sidebarClass = this.$route.name;
    else if(this.$route.name !== 'WatchVideo'){
      this.sidebarClass = "";
    }

  },
  //DOM加載后
  mounted () {

  },
  //方法
  methods: {

    sidebarChange (val) {
      this.sidebarClass = val;
      this.$router.push({ name: val });
    },
    cusLogin () {
      // $("#m-header-nav").hide();
      this.$uikit.offcanvas($("#offcanvas-overlay")).hide();
      this.$router.push({ name: "customerLogin" });
    },
    setIl18 (zh_en) {
      this.I18nValue = zh_en;
    },
    getuser () {
      this.user = this.$store.getters.getcustomer;
      if (
        this.user != null &&
        this.user.userId != undefined &&
        this.user.userId != ""
      ) {
        this.image =
          "https://www.soonnet.org/Account/Acc_Resources/" +
          this.user.userId +
          "/Userlogo_Smail.jpg";
      }
    },
  },
}
</script>
<style scoped>
.sidebar:hover.sidebar::-webkit-scrollbar {
  display: block;
}

.sidebar::-webkit-scrollbar-track {
  background: #f8f9fa
}

.sidebar::-webkit-scrollbar-thumb {
  background: #26ad5e
}

#offcanvas-overlay .sidebar__section__link.link-selected {
  background-color: rgba(0, 0, 0, 0.1);
  font-weight: 500;
  color: #26ad5e !important;
}
#offcanvas-overlay .sidebar__section__link.link-selected i,#offcanvas-overlay .sidebar__section__link.link-selected span{
  color: inherit !important;
}
</style>
<style>
#offcanvas-overlay.menu-desktop.shrink {
  margin-top: 70px;
}

#offcanvas-overlay.menu-desktop,
#offcanvas-overlay.menu-desktop.shrink {
  -webkit-transition: .5s all;
  transition: .5s all;
}

#offcanvas-overlay.menu-desktop {
  margin-top: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/Video/VideoNavigation.vue